// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wsIQ","icon":"styles_icon__2HUpG"};